<template>
  <div class="teaching">
    <div class="teaching-video">
      <div id="mse"></div>
    </div>
    <div class="teaching-m">
      <ul>
        <li v-for="(item, index) in list" :key="item.id" :class="[item.id == $route.query.id ? 'on' : '']">
          <a href="javascript:;" @click="getVideoShow(item)">
            <img :src="item.thumbnail" />
            <span>{{ item.title }}</span>
          </a>
        </li>
      </ul>
    </div>

    <Floating toUrl="/agency/index" />
    <wxNoShare />
  </div>
</template>

<script>
  import { Search, Tab, Tabs } from 'vant'
  import Player from 'xgplayer'

  export default {
    components: {
      [Search.name]: Search,
      [Tabs.name]: Tabs,
      [Tab.name]: Tab
    },
    name: 'teaching',
    data () {
      return {
        list: [],
        playerConfig:{   //3、动态设置相关值
          id: 'mse',
          normalUrl:'',  //普清
          midUrl:'',   //高清
          hightUrl: '', //超清
          poster: '',   //封面
        }
      }
    },
    created () {
      this.getList()
      this.getVideoInfo()
    },
    methods: {
      playerInit () {
        let player = new Player({
          id:'mse',
          autoplay: false,
          url: this.playerConfig.highUrl,   //视频链接
          poster:this.playerConfig.poster,    //封面图片
          fluid: true,   //流式布局
          volume: 0.6,   //初始音量
          //whitelist: ['iPhone','Android'],   //白名单
          playsinline: true,   //内联模式
          videoInit: true,
          'x5-video-player-type': 'h5',
          height: 210,
          width: window.innerWidth,
          playbackRate: [0.5, 0.75, 1, 1.5, 2], //传入倍速可选数组
        })
        // player.emit('resourceReady', [{name: '超清', url: this.playerConfig.highUrl}, {name: '高清', url: this.playerConfig.highUrl},{name: '标清', url: this.playerConfig.highUrl},])
      },
      getVideoInfo(){
        if(this.$route.query.id != undefined) {
          this.$api.get('agency/teachingShow', { id: this.$route.query.id }, r=>{
            this.playerConfig.highUrl = r.data.url    //获取超清视频链接
            this.playerConfig.midUrl = r.data.url    //获取高清视频链接
            this.playerConfig.poster = r.data.thumbnail   //获取视频封面
            this.playerInit()
          })
        }
      },
      getVideoShow(item) {
        window.location.href = '/agency/teaching?id='+item.id
      },
      getList () {
        this.$api.get('agency/teaching', { cid: 9 }, r=>{
          this.list = r.data
        })
      }
    }
  }
</script>

<style scoped>
  .teaching{
    overflow: hidden;
    background: #ffffff;
    height: 100%;
    width: 100%;
  }
  .teaching .teaching-video{
    min-height: 210px;
    width: 100%;
    background: url("https://img.guangdongganfa.com/images/1.jpg") no-repeat;
    background-size: 100%;
  }
  .teaching .teaching-m{
    padding:1.5%;
    overflow: hidden;
  }
  .teaching .teaching-m ul{

  }
  .teaching .teaching-m ul li{
    float: left;
    width: 46%;
    padding:2%;
  }
  .teaching .teaching-m .on{
    background: #ed6a0c;
    border-radius: 2px;
  }
  .teaching .teaching-m ul li a{
    background: #ffffff;
    display: block;
  }
  .teaching .teaching-m ul li img{
    width: 100%;
  }
  .teaching .teaching-m ul li span{
    display: block;
    font-size: 13px;
    padding: 2px 5px;
  }
</style>



// WEBPACK FOOTER //
// src/views/agency/teaching.vue